import React from 'react'
import { NewSearch } from '../../../baseComponent/input'
import TreeList from '../treeList'
import './index.less'

export default ({ keyWords, onLoad, onKeyWords, data, onNext, scrollHeight, style, value, onChange, loading, renderTab }) => {
  const hasCur = data?.[0]?.currentCollectNum

  return <div className="tree-option-content" style={style}>
    <div style={{ padding: '0px 8px' }}>
      <NewSearch
        value={keyWords}
        onChange={val => onKeyWords(val)}
        onClear={() => onKeyWords('')}
        placeholder="搜索灵感集"
      />
    </div>
    {
      !!hasCur && <div className="tree-option-cur-tip">
        该款式已存在于（子）灵感集中，可于下方“已采集”列表内查看详情
      </div>
    }
    <div className="top-title">
      {
        renderTab ? renderTab() : '全部灵感集'
      }
    </div>
    <TreeList
      isEnd={false}
      onLoad={onLoad}
      loading={loading}
      keyWords={keyWords}
      data={data}
      scrollHeight={hasCur ? scrollHeight - 24 : scrollHeight}
      onNext={onNext}
      value={value}
      onChange={onChange}
    />
  </div>
}
